/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CompanyDetailsViewModel,
  ErrorResult,
  NotFoundErrorResult,
  Result,
  ResultOfCompanyDetailsViewModel,
  ValidationErrorResult,
} from '../models';
import {
    CompanyDetailsViewModelFromJSON,
    CompanyDetailsViewModelToJSON,
    ErrorResultFromJSON,
    ErrorResultToJSON,
    NotFoundErrorResultFromJSON,
    NotFoundErrorResultToJSON,
    ResultFromJSON,
    ResultToJSON,
    ResultOfCompanyDetailsViewModelFromJSON,
    ResultOfCompanyDetailsViewModelToJSON,
    ValidationErrorResultFromJSON,
    ValidationErrorResultToJSON,
} from '../models';

export interface CompanyDetailsGetRequest {
    proposalId: number;
}

export interface CompanyDetailsPostRequest {
    proposalId: number;
    companyDetailsViewModel: CompanyDetailsViewModel;
}

/**
 * 
 */
export class CompanyDetailsApi extends runtime.BaseAPI {

    /**
     * Get personal details for a company.
     */
    async companyDetailsGetRaw(requestParameters: CompanyDetailsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfCompanyDetailsViewModel>> {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) {
            throw new runtime.RequiredError('proposalId','Required parameter requestParameters.proposalId was null or undefined when calling companyDetailsGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/personal-details/company/{proposalId}`.replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfCompanyDetailsViewModelFromJSON(jsonValue));
    }

    /**
     * Get personal details for a company.
     */
    async companyDetailsGet(requestParameters: CompanyDetailsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfCompanyDetailsViewModel> {
        const response = await this.companyDetailsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Posts the party\'s personal details for a company.
     */
    async companyDetailsPostRaw(requestParameters: CompanyDetailsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) {
            throw new runtime.RequiredError('proposalId','Required parameter requestParameters.proposalId was null or undefined when calling companyDetailsPost.');
        }

        if (requestParameters.companyDetailsViewModel === null || requestParameters.companyDetailsViewModel === undefined) {
            throw new runtime.RequiredError('companyDetailsViewModel','Required parameter requestParameters.companyDetailsViewModel was null or undefined when calling companyDetailsPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/personal-details/company/{proposalId}`.replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompanyDetailsViewModelToJSON(requestParameters.companyDetailsViewModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Posts the party\'s personal details for a company.
     */
    async companyDetailsPost(requestParameters: CompanyDetailsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.companyDetailsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
